import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import coastalPath1_small from '../../img/walks/coastalPath1_small.jpg'; 
import coastalPath1_medium from '../../img/walks/coastalPath1_medium.jpg'; 
import coastalPath1_large from '../../img/walks/coastalPath1_large.jpg'; 
import coastalPath2_small from '../../img/walks/coastalPath2_small.jpg'; 
import coastalPath2_medium from '../../img/walks/coastalPath2_medium.jpg'; 
import coastalPath2_large from '../../img/walks/coastalPath2_large.jpg'; 

const WalkCorranCoastalDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Corran Coastal Path</h2>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-directions">1. Park at the Ceiliadh House Corran.
            </p>      
            <p className="walk-directions">2. Cross the bridge and turn right. Pass Sheena’s Tea Hut and follow the coast path.
            </p>      
            <p className="walk-directions">3. Pass the last house in Corran and at a rocky beach take a route up through the trees. This soon comes back down to a lovely stretch of pebbly beach.
            </p>      
            <p className="walk-directions">4. At the end of the beach follow round the headland. There are lots of little coves to relax and maybe have a dip.
            </p>      
            <p className="walk-directions">5. The path passes through a natural gap in the rocks further on and you get a view of the three isles and Barrisdale across the loch. The path ends at a beach.
            </p>      
            <p className="walk-directions">6. Return by the same route. Then tea at Sheena’s.
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">2-3 hours
            </p>                                           
          </div>
        </div>
      </div>
    <div className="col-12 imagesBackgroundColour walk-image">
      <picture>
        <source srcSet={`${coastalPath1_small} 1x,${coastalPath1_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${coastalPath1_medium} 1x,${coastalPath1_large} 2x`}
          src={coastalPath1_medium} alt="Coastal Path Windeangle" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour walk-image">
    <picture>
        <source srcSet={`${coastalPath2_small} 1x,${coastalPath2_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${coastalPath2_medium} 1x,${coastalPath2_large} 2x`}
          src={coastalPath2_medium} alt="Coastal Path Winter Cove" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkCorranCoastalDetails
